import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export function extractTimezoneOffset(
  dateString?: string | null,
): string | null {
  if (typeof dateString !== 'string') return null;

  const timePart = dateString.split('T')[1];
  if (!timePart) return null;

  const match = timePart.match(/([+-]\d{2}:?\d{0,2}|Z)$/);
  if (!match) return null;

  let timezone = match[1];
  if (timezone === 'Z') return '+00:00';
  if (!timezone.includes(':')) {
    timezone =
      timezone.length === 3
        ? `${timezone}:00`
        : `${timezone.slice(0, 3)}:${timezone.slice(3)}`;
  }
  return timezone;
}

export function isEddToday(dateString?: string | null): boolean {
  if (!dateString) return false;

  const date = parseISO(dateString);
  if (Number.isNaN(date.getTime())) return false;

  const timezone = extractTimezoneOffset(dateString);

  if (!timezone) {
    const now = new Date();
    return (
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate()
    );
  }

  return (
    formatInTimeZone(date, timezone, 'yyyy-MM-dd') ===
    formatInTimeZone(new Date(), timezone, 'yyyy-MM-dd')
  );
}
